<template>
  <button
    :type="type"
    class="inline-flex h-10 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-primary-600 px-4 text-[13px] font-bold text-white shadow-[0_10px_24px_-10px_rgba(0,102,102,0.7)] transition-colors hover:bg-primary-700 disabled:cursor-not-allowed disabled:opacity-50"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "PagePrimaryButton"
};
</script>

<script setup>
defineProps({
  type: {
    type: String,
    default: "button"
  }
});
</script>
